import { IconName } from "../../shared/Icon";

export interface TemplateItemInfo {
  label: string;
  width: number;
  height: number;
  data: string;
  icon: IconName;
}

export type TemplateItemCategories = keyof typeof Templates;

const Templates: {
  common: TemplateItemInfo[];
  mobile: TemplateItemInfo[];
  sns: TemplateItemInfo[];
  print: TemplateItemInfo[];
  web: TemplateItemInfo[];
  presentation: TemplateItemInfo[];
} = {
  common: [
    {
      label: "Horizontal",
      width: 1200,
      height: 630,
      data: "",
      icon: "File",
    },
    {
      label: "Vertical",
      width: 630,
      height: 1200,
      data: "",
      icon: "File",
    },
    {
      label: "Square",
      width: 600,
      height: 600,
      data: "",
      icon: "Square",
    },
    {
      label: "Wide Banner",
      width: 1920,
      height: 600,
      data: "",
      icon: "DisplayFill",
    },
    {
      label: "Standard Poster",
      width: 800,
      height: 1200,
      data: "",
      icon: "FileImage",
    },
    {
      label: "Card Format",
      width: 400,
      height: 600,
      data: "",
      icon: "CreditCard",
    },
  ],
  mobile: [
    {
      label: "iPhone 14 Pro",
      width: 1179,
      height: 2556,
      data: "",
      icon: "Phone",
    },
    {
      label: "iPhone X",
      width: 1125,
      height: 2436,
      data: "",
      icon: "Phone",
    },
    {
      label: "iPhone 8/7/6 Plus",
      width: 1242,
      height: 2208,
      data: "",
      icon: "Phone",
    },
    {
      label: "iPhone 8/7/6",
      width: 750,
      height: 1334,
      data: "",
      icon: "Phone",
    },
    {
      label: "Samsung Galaxy S23",
      width: 1080,
      height: 2340,
      data: "",
      icon: "PhoneFill",
    },
    {
      label: "iPad Pro",
      width: 2048,
      height: 2732,
      data: "",
      icon: "Tablet",
    },
    {
      label: "iPad",
      width: 1536,
      height: 2048,
      data: "",
      icon: "Tablet",
    },
  ],
  sns: [
    {
      label: "Twitter Banner",
      width: 1500,
      height: 500,
      data: "",
      icon: "Twitter",
    },
    {
      label: "Twitter Image",
      width: 1200,
      height: 675,
      data: "",
      icon: "Twitter",
    },
    {
      label: "Facebook Cover",
      width: 1640,
      height: 924,
      data: "",
      icon: "Facebook",
    },
    {
      label: "Facebook Post",
      width: 940,
      height: 788,
      data: "",
      icon: "Facebook",
    },
    {
      label: "Facebook Ad",
      width: 1200,
      height: 628,
      data: "",
      icon: "Facebook",
    },
    {
      label: "LinkedIn Cover",
      width: 1584,
      height: 396,
      data: "",
      icon: "Linkedin",
    },
    {
      label: "LinkedIn Post",
      width: 1200,
      height: 627,
      data: "",
      icon: "Linkedin",
    },
    {
      label: "Instagram Story",
      width: 1080,
      height: 1920,
      data: "",
      icon: "Instagram",
    },
    {
      label: "Instagram Post",
      width: 1080,
      height: 1080,
      data: "",
      icon: "Instagram",
    },
    {
      label: "Instagram Reel",
      width: 1080,
      height: 1920,
      data: "",
      icon: "Instagram",
    },
    {
      label: "YouTube Banner",
      width: 2560,
      height: 1440,
      data: "",
      icon: "Youtube",
    },
    {
      label: "YouTube Thumbnail",
      width: 1280,
      height: 720,
      data: "",
      icon: "Youtube",
    },
    {
      label: "YouTube Short",
      width: 1080,
      height: 1920,
      data: "",
      icon: "Youtube",
    },
    {
      label: "TikTok Video",
      width: 1080,
      height: 1920,
      data: "",
      icon: "CameraVideo",
    },
    {
      label: "Standard Pin",
      width: 1000,
      height: 1500,
      data: "",
      icon: "Pinterest",
    },
    {
      label: "Story Pin",
      width: 1080,
      height: 1920,
      data: "",
      icon: "Pinterest",
    },
    {
      label: "Discord Banner",
      width: 960,
      height: 540,
      data: "",
      icon: "Chat",
    },
    {
      label: "Snapchat Geofilter",
      width: 1080,
      height: 1920,
      data: "",
      icon: "Camera",
    },
  ],
  print: [
    {
      label: "Business Card",
      width: 1050,
      height: 600,
      data: "",
      icon: "PersonVcard",
    },
    {
      label: "Flyer A4",
      width: 2480,
      height: 3508,
      data: "",
      icon: "FileEarmarkText",
    },
    {
      label: "Postcard",
      width: 1800,
      height: 1200,
      data: "",
      icon: "CardImage",
    },
    {
      label: "Poster A3",
      width: 3508,
      height: 4961,
      data: "",
      icon: "FileImage",
    },
    {
      label: "Brochure Tri-fold",
      width: 2550,
      height: 3300,
      data: "",
      icon: "BookmarksFill",
    },
    {
      label: "Letter Size",
      width: 2550,
      height: 3300,
      data: "",
      icon: "FileText",
    },
    {
      label: "Greeting Card",
      width: 1500,
      height: 2100,
      data: "",
      icon: "HeartFill",
    },
  ],
  web: [
    {
      label: "Website Banner",
      width: 1920,
      height: 400,
      data: "",
      icon: "Globe",
    },
    {
      label: "Email Header",
      width: 600,
      height: 200,
      data: "",
      icon: "Envelope",
    },
    {
      label: "Blog Header",
      width: 1200,
      height: 300,
      data: "",
      icon: "FilePost",
    },
    {
      label: "Web Ad Banner",
      width: 728,
      height: 90,
      data: "",
      icon: "Award",
    },
    {
      label: "Product Banner",
      width: 1200,
      height: 600,
      data: "",
      icon: "CartFill",
    },
    {
      label: "Footer Banner",
      width: 1920,
      height: 200,
      data: "",
      icon: "Window",
    },
    {
      label: "Hero Section",
      width: 1920,
      height: 1080,
      data: "",
      icon: "Image",
    },
  ],
  presentation: [
    {
      label: "PowerPoint 16:9",
      width: 1920,
      height: 1080,
      data: "",
      icon: "FileSlides",
    },
    {
      label: "PowerPoint 4:3",
      width: 1024,
      height: 768,
      data: "",
      icon: "FileSlides",
    },
    {
      label: "Keynote",
      width: 1920,
      height: 1080,
      data: "",
      icon: "Display",
    },
    {
      label: "Google Slides",
      width: 1600,
      height: 900,
      data: "",
      icon: "FileSlides",
    },
    {
      label: "Infographic",
      width: 800,
      height: 2000,
      data: "",
      icon: "BarChartFill",
    },
    {
      label: "Timeline",
      width: 1200,
      height: 400,
      data: "",
      icon: "ClockFill",
    },
  ],
};

export default Templates;
